export default {
  menu: '',
  images: {},
  existing_submenu: false,
  current_submenu: false,
  currency: false,
}
